import Layout from "@/components/layout/index.vue";
//权限管理
export default [{
    path: "/",
    name: "clientLayout",
    component: Layout,
    meta: {
        title: "客户管理"
    },
    children: [{
            path: '/client/thread',
            name: 'thread',
            meta: {
                title: "线索管理"
            },
            component: () =>
                import ('@/views/client/thread/thread.vue'),
        },
        {
            path: '/client/clients',
            name: 'clients',
            meta: {
                title: "客户管理"
            },
            component: () =>
                import ('@/views/client/clients/client.vue'),
        },
    ]
}];